import './vue-apollo'
import './vue-async-operations'
import './vuelidate'
import './vue-meta'
import './event-hub'
import './vue-deep-set'
import './vue-quill-editor'
import './vuedraggable'
import './vue-reactive-refs'
import './vue-json-pretty'
// import "./vue-i18n";

export { default as vuetify } from './vuetify'
